/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, {useEffect, useState} from 'react';
import {
  // NavLink,
  useHistory,
} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {isString} from 'lodash';

const MenuItem = ({menuItem, isParentExtended = false}) => {
  const [t] = useTranslation();
  const [isMenuExtended, setIsMenuExtended] = useState(isParentExtended);
  const [isExpandable, setIsExpandable] = useState(false);
  const [isMainActive, setIsMainActive] = useState(false);
  const [isOneOfChildrenActive, setIsOneOfChildrenActive] = useState(false);
  const history = useHistory();

  // eslint-disable-next-line no-unused-vars
  const toggleMenu = () => {
    setIsMenuExtended(!isMenuExtended);
  };

  const handleMainMenuAction = (evt) => {
    if (isExpandable) {
      let has2Toggle = true;
      let has2OpenLink = false;

      if (menuItem.expandAndLink) {
        has2Toggle = evt.target.tagName.toLowerCase() === 'i';
        has2OpenLink = !has2Toggle;
      }
      if (has2Toggle) {
        toggleMenu();
      }
      if (!has2OpenLink) {
        return;
      }
    }
    history.push(menuItem.path);
  };

  const calculateIsActive = (url) => {
    setIsMainActive(false);
    setIsOneOfChildrenActive(false);
    if (isExpandable) {
      if (menuItem.path === url) {
        setIsMainActive(true);
      } else {
        menuItem.children.forEach((item) => {
          if (item.path === url) {
            setIsOneOfChildrenActive(true);
            setIsMenuExtended(true);
          } else if (item.children && item.children.length > 0) {
            item.children.forEach((sItem) => {
              if (sItem.path === url) {
                setIsOneOfChildrenActive(true);
                setIsMenuExtended(true);
              }
            });
          }
        });
      }
    } else if (
      menuItem.path === url ||
      (menuItem.rootPath && url.indexOf(menuItem.rootPath) >= 0)
    ) {
      setIsMainActive(true);
    }
  };

  useEffect(() => {
    if (!isMainActive && !isOneOfChildrenActive) {
      setIsMenuExtended(false);
    }
  }, [isMainActive, isOneOfChildrenActive]);

  useEffect(() => {
    setIsExpandable(
      menuItem && menuItem.children && menuItem.children.length > 0
    );
  }, [menuItem]);

  useEffect(() => {
    calculateIsActive(history.location.pathname);
    return history.listen((location) => {
      calculateIsActive(location.pathname);
    });
  }, [history, isExpandable, menuItem]);

  const renderMenuIcon = (item) => {
    if (item.icon) {
      if (isString(item.icon)) {
        return <i className={item.icon} />;
      }
      return item.icon;
    }
    return null;
  };

  return (
    <li className={`nav-item${isMenuExtended ? ' menu-open' : ''}`}>
      <a
        className={`nav-link cce-nav-link${
          isMainActive || isOneOfChildrenActive ? ' active' : ''
        } ${menuItem.className || ''}`}
        role="link"
        onClick={handleMainMenuAction}
        style={{cursor: 'pointer'}}
      >
        {renderMenuIcon(menuItem)}
        <p>{t(menuItem.name)}</p>
        {isExpandable ? <i className="right fas fa-angle-right" /> : null}
      </a>

      {isExpandable && (
        <ul
          className="nav nav-treeview custom-nav-submenu"
          // style={{
          //   marginTop: '-0.4em',
          //   borderBottomLeftRadius: '5px',
          //   borderBottomRightRadius: '5px',
          // }}
        >
          {menuItem.children.map((item) => (
            <SubMenuItem
              key={item.name}
              menuItem={item}
              isParentExtended={isMenuExtended}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const SubMenuItem = ({menuItem, isParentExtended}) => {
  return (
    <MenuItem
      key={menuItem.name}
      menuItem={menuItem}
      isParentExtended={isParentExtended}
    />
  );
};

const MainMenuItem = ({menuItem}) => {
  return <MenuItem key={menuItem.name} menuItem={menuItem} />;
};

export default MainMenuItem;
